import React from 'react'
import { Navigate, Outlet, useRoutes } from 'react-router-dom'
import { AppLayout, LoginLayout } from 'components/layout'
import Home from 'views/home'
import Profile from 'views/auth/Profile'
import Login from 'views/auth/Login'
import ForgotPassword from 'views/auth/ForgotPassword'
import ResetPassword from 'views/auth/ResetPassword'
import Error from 'views/Error'
import Company from 'views/company-management/company'
import CreateCompany from 'views/company-management/company/create'
import CompanyConfiguration from 'views/company-management/company-configuration'
import CreateCompanyConfiguration from 'views/company-management/company-configuration/create'
import CompanyAdmin from 'views/company-management/company-admin'
import CreateCompanyAdmin from 'views/company-management/company-admin/create'
import CompanyUser from 'views/company-management/company-user'
import CreateCompanyUser from 'views/company-management/company-user/create'
import ClientCompany from 'views/company-management/client-company'
import CreateClientCompany from 'views/company-management/client-company/create'
import TransportProvider from 'views/transport-service-provider/transport-provider'
import CreateTransportProvider from 'views/transport-service-provider/transport-provider/create'
import TransportProviderAdmin from 'views/transport-service-provider/transport-provider-admin'
import CreateTransportProviderAdmin from 'views/transport-service-provider/transport-provider-admin/create'
import TransportProviderUser from 'views/transport-service-provider/transport-provider-user'
import CreateTransportProviderUser from 'views/transport-service-provider/transport-provider-user/create'
import TransportProviderService from 'views/transport-service-provider/transport-provider-service'
import TransportRateCalculator from 'views/transport-service-provider/transport-rate-calculator'
import CreateTransportProviderService from 'views/transport-service-provider/transport-provider-service/create'
import RateCard from 'views/master-data/rate-card'
import CreateRateCard from 'views/master-data/rate-card/create'
import ExtraCharges from 'views/master-data/extra-charges'
import CreateExtraCharges from 'views/master-data/extra-charges/create'
import FuelLevy from 'views/master-data/fuel-levy'
import CreateFuelLevy from 'views/master-data/fuel-levy/create'
import FormulaTemplate from 'views/master-data/formula-template'
import CreateFormulaTemplate from 'views/master-data/formula-template/create'
import Assign from 'views/master-data/assign'
import CreateAssign from 'views/master-data/assign/create'
import UploadInvoices from 'views/invoices/upload-invoices'
import CreateUploadInvoices from 'views/invoices/upload-invoices/create'
import VerifiedInvoices from 'views/invoices/verified-invoices'
import ReconcileView from 'views/invoices/verified-invoices/view'
import InvoiceHistory from 'views/invoices/verified-invoices/invoiceHistory'
import PendingInvoices from 'views/invoices/pending-invoices'
import PendingReconcileView from 'views/invoices/pending-invoices/view'
import ApprovedInvoices from 'views/invoices/approved-invoices'
import RejectedInvoices from 'views/invoices/rejected-invoices'

export default function Router() {
    return useRoutes([
        {
            path: '/',
            element: <AppLayout />,
            children: [
                //home
                { path: '/', element: <Home /> },

                //profile
                { path: '/profile', element: <Profile /> },

                //company
                {
                    path: '/company-management/company',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Company /> },
                        { path: 'create', element: <CreateCompany /> },
                        { path: ':id/edit', element: <CreateCompany /> },
                    ],
                },

                //company configuration
                {
                    path: '/company-management/company-configuration',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <CompanyConfiguration /> },
                        {
                            path: 'create',
                            element: <CreateCompanyConfiguration />,
                        },
                        {
                            path: ':id/edit',
                            element: <CreateCompanyConfiguration />,
                        },
                    ],
                },

                //company admin
                {
                    path: '/company-management/company-admin',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <CompanyAdmin /> },
                        { path: 'create', element: <CreateCompanyAdmin /> },
                        { path: ':id/edit', element: <CreateCompanyAdmin /> },
                    ],
                },

                //company user
                {
                    path: '/company-management/company-user',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <CompanyUser /> },
                        { path: 'create', element: <CreateCompanyUser /> },
                        { path: ':id/edit', element: <CreateCompanyUser /> },
                    ],
                },

                //client company
                {
                    path: '/company-management/client-company',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <ClientCompany /> },
                        { path: 'create', element: <CreateClientCompany /> },
                        { path: ':id/edit', element: <CreateClientCompany /> },
                    ],
                },

                //transport service provider
                {
                    path: '/transport-service-provider/transport-provider',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <TransportProvider /> },
                        {
                            path: 'create',
                            element: <CreateTransportProvider />,
                        },
                        {
                            path: ':id/edit',
                            element: <CreateTransportProvider />,
                        },
                    ],
                },

                //transport provider admin
                {
                    path: '/transport-service-provider/transport-provider-admin',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <TransportProviderAdmin /> },
                        {
                            path: 'create',
                            element: <CreateTransportProviderAdmin />,
                        },
                        {
                            path: ':id/edit',
                            element: <CreateTransportProviderAdmin />,
                        },
                    ],
                },

                //transport provider user
                {
                    path: '/transport-service-provider/transport-provider-user',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <TransportProviderUser /> },
                        {
                            path: 'create',
                            element: <CreateTransportProviderUser />,
                        },
                        {
                            path: ':id/edit',
                            element: <CreateTransportProviderUser />,
                        },
                    ],
                },

                //transport provider service
                {
                    path: '/transport-service-provider/transport-provider-service',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <TransportProviderService /> },
                        {
                            path: 'create',
                            element: <CreateTransportProviderService />,
                        },
                        {
                            path: ':id/edit',
                            element: <CreateTransportProviderService />,
                        },
                    ],
                },

                //transport rate calculator
                {
                    path: '/transport-service-provider/transport-rate-calculator',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <TransportRateCalculator /> },
                    ],
                },

                //rate card
                {
                    path: '/master-data/rate-card',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <RateCard /> },
                        { path: 'create', element: <CreateRateCard /> },
                        { path: ':id/edit', element: <CreateRateCard /> },
                    ],
                },

                //extra charges
                {
                    path: '/master-data/extra-charges',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <ExtraCharges /> },
                        { path: 'create', element: <CreateExtraCharges /> },
                        { path: ':id/edit', element: <CreateExtraCharges /> },
                    ],
                },

                //fuel levy
                {
                    path: '/master-data/fuel-levy',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <FuelLevy /> },
                        { path: 'create', element: <CreateFuelLevy /> },
                        { path: ':id/edit', element: <CreateFuelLevy /> },
                    ],
                },

                //formula template
                {
                    path: '/master-data/formula-template',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <FormulaTemplate /> },
                        { path: 'create', element: <CreateFormulaTemplate /> },
                        {
                            path: ':id/edit',
                            element: <CreateFormulaTemplate />,
                        },
                    ],
                },

                //assign
                {
                    path: '/master-data/assign',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Assign /> },
                        { path: 'create', element: <CreateAssign /> },
                        { path: ':id/edit', element: <CreateAssign /> },
                    ],
                },

                //upload invoices
                {
                    path: '/invoices/upload-invoices',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <UploadInvoices /> },
                        { path: 'create', element: <CreateUploadInvoices /> },
                        { path: ':id/edit', element: <CreateUploadInvoices /> },
                    ],
                },

                //verified invoices
                {
                    path: '/invoices/verified-invoices',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <VerifiedInvoices /> },
                        { path: ':id/result', element: <ReconcileView /> },
                        {
                            path: ':id/invoice-history',
                            element: <InvoiceHistory />,
                        },
                    ],
                },

                //pending invoices
                {
                    path: '/invoices/pending-invoices',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <PendingInvoices /> },
                        {
                            path: ':id/result',
                            element: <PendingReconcileView />,
                        },
                    ],
                },

                //approved invoices
                {
                    path: '/invoices/approved-invoices',
                    element: <Outlet />,
                    children: [{ path: '', element: <ApprovedInvoices /> }],
                },

                //rejected invoices
                {
                    path: '/invoices/rejected-invoices',
                    element: <Outlet />,
                    children: [{ path: '', element: <RejectedInvoices /> }],
                },
            ],
        },
        {
            path: '/',
            element: <LoginLayout />,
            children: [
                { path: '/login', element: <Login /> },
                { path: '/forgot-password', element: <ForgotPassword /> },
                {
                    path: '/activate/:uid/:token',
                    element: <ResetPassword />,
                },
            ],
        },
        { path: 'error', element: <Error /> },
        { path: '*', element: <Navigate to="/error" replace /> },
    ])
}
